import { useState } from "react";
import LoggedInNavbar from "../../Admin/helper/loggedInNavbar";
import AddUser from "./userManagement/adduser";
import DeleteUser from "./userManagement/deleteUser";
import AddMedia from "./mediaManagement/addMedia";
import DeleteMedia from "./mediaManagement/deleteMedia";
import CalendarManagement from "./calendarManagement/calendarManagement";
import { Link } from "react-router-dom";

const AdminDashboard = () => {
  const [getaction, setaction] = useState(0);
  const handleBack = () => setaction(0);

  const C = {
    saffron: "#E34607",
    saffronBg: "#FFF4EE",
    gold: "#B45309",
    goldBg: "#FFFBEB",
    teal: "#0F766E",
    tealBg: "#F0FDFA",
    maroon: "#9B1C1C",
    maroonBg: "#FFF5F5",
    indigo: "#4338CA",
    indigoBg: "#EEF2FF",
    olive: "#3D6B35",
    oliveBg: "#F0FDF4",
    border: "#E8E4DE",
    pageBg: "#F7F5F2",
    cardBg: "#FFFFFF",
    text: "#1C1917",
    muted: "#78716C",
  };

  // ── Card ──────────────────────────────────────────────────────────────────
  const Card = ({ children, style }) => (
    <div
      style={{
        backgroundColor: C.cardBg,
        borderRadius: 12,
        border: `1px solid ${C.border}`,
        boxShadow: "0 1px 6px rgba(0,0,0,0.06)",
        overflow: "hidden",
        ...style,
      }}
    >
      {children}
    </div>
  );

  // ── Card header ───────────────────────────────────────────────────────────
  const CardHeader = ({ icon, title, accent, accentBg, right }) => (
    <div
      style={{
        padding: "14px 20px",
        borderBottom: `1px solid ${C.border}`,
        display: "flex",
        alignItems: "center",
        gap: 10,
        backgroundColor: "#FAFAF9",
      }}
    >
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: 8,
          backgroundColor: accentBg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <i className={`fas ${icon}`} style={{ fontSize: 13, color: accent }} />
      </div>
      <span style={{ fontSize: 14, fontWeight: 700, color: C.text }}>
        {title}
      </span>
      {right && <div style={{ marginLeft: "auto" }}>{right}</div>}
    </div>
  );

  // ── Action button (onClick) ───────────────────────────────────────────────
  const Btn = ({ bg, color, border, icon, label, onClick }) => (
    <button
      onClick={onClick}
      style={{
        backgroundColor: bg,
        color,
        border: `1.5px solid ${border}`,
        borderRadius: 8,
        padding: "10px 14px",
        fontSize: 13,
        fontWeight: 600,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        width: "100%",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.filter = "brightness(0.94)")}
      onMouseLeave={(e) => (e.currentTarget.style.filter = "brightness(1)")}
    >
      <i className={`fas ${icon}`} style={{ fontSize: 11 }} />
      {label}
    </button>
  );

  // ── Link button (navigates) ───────────────────────────────────────────────
  const LinkBtn = ({ to, bg, color, border, icon, label }) => (
    <Link to={to} style={{ display: "block", textDecoration: "none" }}>
      <button
        style={{
          backgroundColor: bg,
          color,
          border: `1.5px solid ${border}`,
          borderRadius: 8,
          padding: "10px 14px",
          fontSize: 13,
          fontWeight: 600,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 6,
          width: "100%",
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.filter = "brightness(0.94)")
        }
        onMouseLeave={(e) => (e.currentTarget.style.filter = "brightness(1)")}
      >
        <i className={`fas ${icon}`} style={{ fontSize: 11 }} />
        {label}
      </button>
    </Link>
  );

  // ── Media section (label + upload/edit pair) ──────────────────────────────
  const MediaSection = ({ label, dot, uploadTo, editTo }) => (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 7,
          marginBottom: 8,
          marginTop: 18,
        }}
      >
        <div
          style={{
            width: 7,
            height: 7,
            borderRadius: "50%",
            backgroundColor: dot,
            flexShrink: 0,
          }}
        />
        <span
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: C.muted,
            textTransform: "uppercase",
            letterSpacing: "0.06em",
          }}
        >
          {label}
        </span>
        <div style={{ flex: 1, height: 1, backgroundColor: C.border }} />
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 7 }}>
        <LinkBtn
          to={uploadTo}
          bg={C.oliveBg}
          color={C.olive}
          border={C.olive + "55"}
          icon="fa-upload"
          label="Upload"
        />
        <LinkBtn
          to={editTo}
          bg={C.goldBg}
          color={C.gold}
          border={C.gold + "55"}
          icon="fa-edit"
          label="Edit"
        />
      </div>
    </div>
  );

  const MEDIA = [
    {
      label: "Videos",
      dot: C.olive,
      uploadTo: "/admindashboard/uploadvideos",
      editTo: "/admindashboard/editvideos",
    },
    {
      label: "Speech",
      dot: C.teal,
      uploadTo: "/admindashboard/uploadspeech",
      editTo: "/admindashboard/editspeech",
    },
    {
      label: "Songs",
      dot: C.gold,
      uploadTo: "/admindashboard/uploadsongs",
      editTo: "/admindashboard/editsongs",
    },
    {
      label: "Images",
      dot: C.indigo,
      uploadTo: "/admindashboard/uploadimages",
      editTo: "/admindashboard/editimage",
    },
    {
      label: "Documents",
      dot: C.maroon,
      uploadTo: "/admindashboard/uploaddocuments",
      editTo: "/admindashboard/editdocuments",
    },
  ];

  return (
    <>
      <LoggedInNavbar />

      <div
        style={{
          backgroundColor: C.pageBg,
          minHeight: "100vh",
          padding: "20px 24px 32px",
        }}
      >
        {/* ── Page header ─────────────────────────────────────────────────── */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 20,
            paddingBottom: 16,
            borderBottom: `1px solid ${C.border}`,
          }}
        >
          <div
            style={{
              width: 4,
              height: 26,
              backgroundColor: C.saffron,
              borderRadius: 2,
            }}
          />
          <span style={{ fontSize: 20, fontWeight: 700, color: C.text }}>
            Admin Dashboard
          </span>
          <span
            style={{
              marginLeft: 8,
              backgroundColor: C.saffronBg,
              color: C.saffron,
              fontSize: 11,
              fontWeight: 600,
              padding: "3px 10px",
              borderRadius: 20,
              border: `1px solid ${C.saffron}33`,
            }}
          >
            Hari Krishna Mandir
          </span>
        </div>

        {/* ── Row 1: User Management + Calendar Management ─────────────────
              Two cards side by side, each taking equal width.
              The right half stays deliberately empty — exactly like original.
        ─────────────────────────────────────────────────────────────────── */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 16,
            marginBottom: 16,
          }}
        >
          {/* User Management */}
          <Card>
            <CardHeader
              icon="fa-users"
              title="User management"
              accent={C.saffron}
              accentBg={C.saffronBg}
            />
            <div style={{ padding: "16px 20px" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: 10,
                }}
              >
                <Btn
                  bg={C.oliveBg}
                  color={C.olive}
                  border={C.olive + "55"}
                  icon="fa-user-plus"
                  label="Add user"
                  onClick={() => setaction(1)}
                />
                <Btn
                  bg={C.maroonBg}
                  color={C.maroon}
                  border={C.maroon + "55"}
                  icon="fa-user-minus"
                  label="Delete user"
                  onClick={() => setaction(2)}
                />
                <Btn
                  bg={C.indigoBg}
                  color={C.indigo}
                  border={C.indigo + "55"}
                  icon="fa-eye"
                  label="View users"
                  onClick={() => setaction(6)}
                />
              </div>
            </div>
          </Card>

          {/* Calendar Management */}
          <Card>
            <CardHeader
              icon="fa-calendar-alt"
              title="Calendar management"
              accent={C.teal}
              accentBg={C.tealBg}
            />
            <div style={{ padding: "16px 20px" }}>
              <Btn
                bg={C.tealBg}
                color={C.teal}
                border={C.teal + "55"}
                icon="fa-calendar-plus"
                label="Manage calendar dates"
                onClick={() => setaction(5)}
              />
            </div>
          </Card>
        </div>

        {/* ── Row 2: Media Management — full width ────────────────────────── */}
        <Card style={{ marginBottom: 16 }}>
          <CardHeader
            icon="fa-film"
            title="Media management"
            accent={C.saffron}
            accentBg={C.saffronBg}
            right={
              <span
                style={{ fontSize: 11, color: "#bbb", fontStyle: "italic" }}
              >
                Upload &amp; edit grouped by content type
              </span>
            }
          />
          <div style={{ padding: "0 20px 20px" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(5, 1fr)",
                gap: "0 20px",
              }}
            >
              {MEDIA.map((m) => (
                <MediaSection key={m.label} {...m} />
              ))}
            </div>
          </div>
        </Card>

        {/* ── Content area ────────────────────────────────────────────────── */}
        <div>
          {getaction === 1 ? (
            <AddUser onBack={handleBack} />
          ) : getaction === 2 ? (
            <DeleteUser onBack={handleBack} mode="delete" />
          ) : getaction === 3 ? (
            <AddMedia />
          ) : getaction === 5 ? (
            <CalendarManagement onBack={handleBack} />
          ) : getaction === 6 ? (
            <DeleteUser onBack={handleBack} mode="view" />
          ) : (
            <DeleteMedia />
          )}
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
